/**
 * Groups attachments by subject titles.
 *
 * @param {array} attachments
 * @returns {Object} i.e. { ELA: [attachments], Science: [attachments]}
 */
const groupAttachmentsBySubjectType = (attachments) => {
  if (!attachments) return [];

  const attachmentsToBeGrouped = {};
  for (const attachment of attachments) {
    const currentSubject =
      attachment?.subject?.data?.name ??
      attachment?.subject?.data?.subject ??
      attachment?.subject?.subject;
    if (currentSubject) {
      if (attachmentsToBeGrouped[currentSubject]) {
        attachmentsToBeGrouped[currentSubject] = [
          ...attachmentsToBeGrouped[currentSubject],
          attachment,
        ];
      } else {
        attachmentsToBeGrouped[currentSubject] = [attachment];
      }
    }
  }

  return attachmentsToBeGrouped;
};

export default groupAttachmentsBySubjectType;
